import React from 'react';
import { Award, Shield, Lightbulb, Leaf } from 'lucide-react';
import { values } from '../data/mock';

const iconMap = {
  Award,
  Shield,
  Lightbulb,
  Leaf
};

// Colors based on logo
const valueColors = [
  { bg: 'bg-sky-500', light: 'bg-sky-100', text: 'text-sky-600', hover: 'hover:bg-sky-50' },
  { bg: 'bg-yellow-400', light: 'bg-yellow-100', text: 'text-yellow-600', hover: 'hover:bg-yellow-50' },
  { bg: 'bg-green-500', light: 'bg-green-100', text: 'text-green-600', hover: 'hover:bg-green-50' },
  { bg: 'bg-orange-500', light: 'bg-orange-100', text: 'text-orange-600', hover: 'hover:bg-orange-50' }
];

const ValuesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sky-500 font-semibold text-sm uppercase tracking-wider mb-3">
            Our Foundation
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            Our Values
          </h2>
          <p className="text-slate-600 text-lg">
            The principles that guide our work and define our commitment to excellence.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => {
            const IconComponent = iconMap[value.icon];
            const colors = valueColors[index % valueColors.length];
            return (
              <div
                key={value.id}
                className={`group text-center p-8 rounded-2xl bg-slate-50 ${colors.hover} transition-all duration-300 hover:shadow-lg`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`w-16 h-16 rounded-2xl bg-white shadow-md flex items-center justify-center mx-auto mb-6 group-hover:${colors.bg} group-hover:shadow-lg transition-all duration-300`}>
                  {IconComponent && (
                    <IconComponent className={`w-8 h-8 ${colors.text} group-hover:text-white transition-colors`} />
                  )}
                </div>
                <h3 className="text-xl font-semibold text-slate-800 mb-2">
                  {value.title}
                </h3>
                <p className="text-slate-500">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
